import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
// import Toggle from 'react-toggle'
import axios from 'axios'
import ActivitiesController from '../../../common/activitiesController/ActivitiesController'

class TripItineraryList extends React.Component {
  state = {
    data: [],
    isEditing: false,
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    await axios
      .get(Constant.getAPI() + `/trips/get-all-trip-itineraries/${this.props.match.params.tripId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteCruiseItinerary = async (id) => {
    await axios
      .delete(Constant.getAPI() + '/trips/delete-trip-itinerary/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Deleted !', 'Cruise Itinerary deleted!', 'success')
          this.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'img_en',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (img) => {
            return (
              <>
                <img
                  src={Constant.getImage() + img}
                  className="img-fluid img-50"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <>
                <div>
                  <Link
                    to={`/cruise-trip-itinerary/${this.props.match.params.tripId}/add/` + id}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="View Cruise Details "
                  >
                    <i className="f-22 icofont icofont-ui-edit text-dark"></i>
                  </Link>
                  <span
                    onClick={this.deleteCruiseItinerary.bind(this, id)}
                    className="m-r-15 text-muted"
                    data-toggle="tooltip"
                    data-placement="top"
                    title=""
                    data-original-title="Delete"
                  >
                    <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                  </span>
                  <ActivitiesController refId={id}>Activities</ActivitiesController>
                </div>
              </>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Cruise Itinerary List</h4>
                    </div>
                  </div>
                  {this.state.data.length == 0 && (
                    <Link
                      to={`/cruise-trip-itinerary/${this.props.match.params.tripId}/add`}
                      className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                      data-modal="modal-13"
                    >
                      {' '}
                      <i className="icofont icofont-plus m-r-5"></i> Add Cruise Itinerary
                    </Link>
                  )}
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/cruise-trip-details/${this.props.match?.params?.tripId}`}>Cruise Trip Details</Link>
                      </li>
                      <li className="breadcrumb-item active">Cruise Itinerary List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title={'Cruise Itinerary List'}
                        className="table-responsive"
                        data={this.state.data}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripItineraryList
